import { motion, useTransform } from "framer-motion";
import photo from "../assets/iconOnly.png";

export default function Home({ scrollYProgress }) {
  
    const m = window.innerWidth < 768;
    
    const y = useTransform(scrollYProgress, [0, 1], [0, -500], {
        clamp: false
    })

    const y2 = useTransform(scrollYProgress, [0, 0.2], [0, -window.innerHeight], {
        clamp: false
    })

    const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [1, 0.4, 0.4], {
        clamp: true
    })

    const o2 = useTransform(scrollYProgress, [0, 0.1, 1], [1, 0, 0], {
        clamp: true
    })

    return (
        <>
            {!m && <motion.div
                initial={{ y: -300, opacity: 0.4 }}
                animate={{ y: 0, opacity: 0.8 }}
                style={{ position: 'fixed', pointerEvents: 'none', top: 0, left: 0, width: "100vw", height: "100vh", zIndex: -1 }}
            >
                <motion.img
                    alt="by AltumCode on Unsplash" 
                    src={photo}
                    className="icon-display"
                    style={{ 
                        y, 
                        opacity,
                        "-webkit-filter": `brightness(0) invert(1)`,
                        filter: `brightness(0) invert(1)`
                    }} 
                />
            </motion.div>}
            <motion.div style={{ position: "sticky", top: "10vh", zIndex: -1,  y, opacity, textAlign: m ? "center" : "left", pointerEvents: "all" }} id="home">
                <motion.h1 initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="title-header">PandS Tech Solutions</motion.h1>
                <motion.h1 initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.2 }} className="title">Innovative Software Solutions</motion.h1>
            </motion.div>
            <motion.div style={{ zIndex: 500, position: "absolute", top: window.innerHeight - (m ? 230 : 180), margin: m ? "0 auto" : "0 100px", y: y2, opacity: o2, display: "flex", justifyContent: m ? 'center' : "flex-start", width: "100vw" }} >
                <button 
                    className="pointer" style={{ pointerEvents: 'all', cursor: 'pointer' }} 
                    onClick={() => {
                        const container = document.getElementById("reach-out")
                        container.scrollIntoView(true)

                }}>Request Quote</button>
            </motion.div>
        </>
    )
}